module.exports = __webpack_public_path__ + "img/mailuo.4ff96c85.png";